import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "authentication-area" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = { class: "authentication-form" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-danger py-2 mb-3"
}
const _hoisted_7 = { class: "form-floating mb-4" }
const _hoisted_8 = { class: "form-floating mb-4" }
const _hoisted_9 = { class: "form-floating mb-4" }
const _hoisted_10 = { class: "form-floating mb-4" }
const _hoisted_11 = { class: "form-check mb-4" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "border-style" }
const _hoisted_15 = { class: "py-4 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[13] || (_cache[13] = _createElementVNode("h2", null, "Register", -1)),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.error), 1))
              : _createCommentVNode("", true),
            _createElementVNode("form", {
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleRegister && _ctx.handleRegister(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                  type: "text",
                  class: "form-control",
                  id: "floatingInput3",
                  placeholder: "Name",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.name]
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("label", {
                  for: "floatingInput3",
                  class: "floating"
                }, "Name", -1))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                  type: "email",
                  class: "form-control",
                  id: "floatingInput4",
                  placeholder: "Email",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("label", {
                  for: "floatingInput4",
                  class: "floating"
                }, "Email", -1))
              ]),
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.phone) = $event)),
                  type: "tel",
                  class: "form-control",
                  id: "floatingInputPhone",
                  placeholder: "Phone Number"
                }, null, 512), [
                  [_vModelText, _ctx.phone]
                ]),
                _cache[8] || (_cache[8] = _createElementVNode("label", {
                  for: "floatingInputPhone",
                  class: "floating"
                }, "Phone Number (optional)", -1))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password) = $event)),
                  type: "password",
                  class: "form-control",
                  id: "floatingInput5",
                  placeholder: "Password",
                  minlength: "8",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.password]
                ]),
                _cache[9] || (_cache[9] = _createElementVNode("label", {
                  for: "floatingInput5",
                  class: "floating"
                }, "Password", -1))
              ]),
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.agreed) = $event)),
                  class: "form-check-input",
                  type: "checkbox",
                  id: "flexCheckDefault2",
                  required: ""
                }, null, 512), [
                  [_vModelCheckbox, _ctx.agreed]
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("label", {
                  class: "form-check-label position-relative tops-2",
                  for: "flexCheckDefault2"
                }, " I accept all terms & conditions ", -1))
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn px-275",
                  disabled: _ctx.loading
                }, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.loading ? "Creating account..." : "Register Now"), 1)
                ], 8, _hoisted_13)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[12] || (_cache[12] = _createTextVNode(" Already have an account? ")),
                _createVNode(_component_RouterLink, {
                  to: "/login",
                  class: "text-white fw-bold"
                }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createTextVNode("Login")
                  ])),
                  _: 1
                })
              ])
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}